export default __webpack_public_path__ + "static/media/message.5e3a8b55.png";